import { render, staticRenderFns } from "./UserFieldEditForm.vue?vue&type=template&id=a104dc54&scoped=true&"
import script from "./UserFieldEditForm.vue?vue&type=script&lang=js&"
export * from "./UserFieldEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldEditForm.vue?vue&type=style&index=0&id=a104dc54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a104dc54",
  null
  
)

export default component.exports